module.exports = __webpack_public_path__ + "img/26.8a88c989.svg";